import React, { useMemo, useContext } from 'react';
// import { Switch, Redirect, Route } from 'react-router';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { getObject } from '../util/mapObject';


function RouteSwitch({ routes }) {
  const auth = useContext(AuthContext);
  const navigate = useNavigate();

  const allowedRoutes = useMemo(() => Object.entries(routes).filter(
    entry => checkRequirements(auth, entry[1].requires)
  ), [auth]);

  const defaultRoute = useMemo(() => (
    allowedRoutes.filter(entry => entry[1].default).sort(
      (a, b) => b[1].default - a[1].default
    )[0]
  ), [allowedRoutes]);

  return (<Routes>
        {allowedRoutes.map(([path, { requires, component, ...route }], idx) => {
          const Component = component
          return (
            <Route
              key={idx}
              path={path}
              navigate={navigate}
              element={<Component />}
              {...route}
            />
        )})}
        {defaultRoute ? (
          <Route path="*" element={<Navigate to={defaultRoute[0]} replace />} />
        ) : null}
    </Routes>);
}


function checkRequirements({ user }, requires) {
  if (requires === 'login') {
    return !!user;
  } else if (typeof requires === 'string'){
    return !!getObject(user, requires);
  }

  return true;
}


export default RouteSwitch;